module.exports = __webpack_public_path__ + "media/application/assets/images/logo_placeholder-7beb2d2855c23a47fb05f7a83405b9be.jpg";